import React from "react";
import { useParams } from "react-router-dom";

import { useGetCustomerOrderData } from "../../hooks";
import { OrdersTable } from "../OrdersTable";

export const CustomerOrdersTable = () => {
  const { id } = useParams();
  const { data } = useGetCustomerOrderData(id);
  const meta = data?.meta;

  return <OrdersTable rows={data?.rows} meta={meta} hideCustomer />;
};

export default CustomerOrdersTable;
